import { useEffect } from 'react';

import type { EmailListItemAttributes } from 'hb-builder/components/BuilderComponents/dynamic/EmailList/types';
import ButtonLink from 'hb-builder/components/common/SettingsLibrary/CommonSettings/ButtonLink';
import DisplayFieldOption from 'hb-builder/components/common/SettingsLibrary/CommonSettings/DisplayFieldOption';
import TextSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/TextSetting';
import AccordionTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/AccordionTitle';
import { useBuilderConfigContext } from 'hb-builder/hooks';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';

const LINKS = Object.freeze({
  news: (ids) =>
    ids.topic
      ? `${window.location.origin}/topics/${ids.topic}/news`
      : `${window.location.origin}/news`,
  events: (ids) =>
    ids.topic
      ? `${window.location.origin}/topics/${ids.topic}/events`
      : `${window.location.origin}/events`,
});

const ButtonSettings = ({
  item,
  onChange,
}: Pick<
  ComponentSettingsTab<EmailListItemAttributes>,
  'item' | 'onChange'
>) => {
  const {
    hivebrite: { ids },
  } = useBuilderConfigContext();

  const settingProps = { item, onChange };
  const { dynamicAttributes } = item.attributes || {};
  const { type } = dynamicAttributes || {};

  const link = type === 'news' ? LINKS.news(ids) : LINKS.events(ids);

  const newAttributes = {
    ...item.attributes,
    buttonLink:
      item.attributes?.buttonLink === undefined
        ? link
        : item.attributes.buttonLink,
  };

  const newItem = { ...item, attributes: newAttributes };

  useEffect(() => {
    onChange({
      id: item.id,
      settingKey: 'attributes.buttonLink',
      value: link,
    });
  }, [type]);

  return (
    <AccordionTitle title={__('Button')}>
      <DisplayFieldOption
        keySetter="attributes.dynamicAttributes.button.display"
        label={__('Display Button')}
        {...settingProps}
      />
      <TextSetting
        initialValue={s__('See all %{type}').i__({ type: type || '' })}
        settingKey="attributes.dynamicAttributes.button.content"
        title={__('Content')}
        {...settingProps}
      />
      <ButtonLink
        item={newItem}
        onChange={onChange}
        placeholder={__('Add your index page link here')}
      />
      <DisplayFieldOption
        disabled={item.attributes?.buttonLink?.startsWith('mailto:')}
        keySetter="attributes.dynamicAttributes.button.newPage"
        label={__('Open link in a new tab')}
        {...settingProps}
      />
    </AccordionTitle>
  );
};

export default ButtonSettings;
